import React from "react";
import { useTranslation } from "react-i18next";
import OInputField from "../../components/reusable/OInputField";
import OSelect from "../../components/reusable/OSelect";

const CompensationStep = ({ register, errors, watch, permission, user }) => {
  const { t } = useTranslation();
  const salaryMin = Number(watch?.("salaryMin")) || 0;
  const salaryMax = Number(watch?.("salaryMax")) || 0;
  const currencyOptions = [
    { value: "AED", key: "AED" },
    { value: "SAR", key: "SAR" },
    { value: "USD", key: "USD" },
  ];

  const invalidRange = salaryMax && salaryMin && salaryMin > salaryMax;

  return (
    <div>
      <div className="grid md:grid-cols-3 gap-6 mb-2">
        <OInputField
          inputLabel={t("Salary Min")}
          name="salaryMin"
          type="number"
          placeholder="0"
          disabled={!(permission?.add || user.role === "admin")}
          register={register("salaryMin", { valueAsNumber: true })}
          errors={errors}
        />
        <OInputField
          inputLabel={t("Salary Max")}
          name="salaryMax"
          type="number"
          placeholder="0"
          disabled={!(permission?.add || user.role === "admin")}
          register={register("salaryMax", { valueAsNumber: true })}
          errors={errors}
        />
        <OSelect
          inputLabel={t("WALLET_CURRENCY")}
          name="currency"
          disabled={!(permission?.add || user.role === "admin")}
          register={register("currency")}
          errors={errors}
          options={currencyOptions}
          placeholder="Select currency"
        />
      </div>
      {invalidRange ? (
        <div className="text-xs text-red-600 mb-2">
          {t("Salary Min should be less than or equal to Salary Max")}
        </div>
      ) : null}
      <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-md mt-2">
        <input
          id="isNegotiable"
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300"
          disabled={!(permission?.add || user.role === "admin")}
          {...register("isNegotiable")}
        />
        <label
          htmlFor="isNegotiable"
          className="text-sm font-medium text-gray-700"
        >
          {t("isNegotiable") || "Salary is Negotiable"}
        </label>
      </div>
    </div>
  );
};

CompensationStep.fields = ["salaryMin", "salaryMax", "currency"];

export default CompensationStep;
